<template>
    <div>
      <b-form-select
            v-if="update"
            :name="storeInArray ? `formData${storeInArray}[${currentField.tagname}]` : `formData[${currentField.tagname}]`"
            v-model="selected"
            :options="currentField.options"
            placeholder="Select"
            :loading="loading"
            v-bind="attributesBinding"
            size="sm" style="height: 38px"
            text-field="optionLabel"
            :class="{'is-invalid' : error}"
            value-field="optionValue"
          >
          </b-form-select>
          <span class="invalid-feedback" role="alert" v-if="error">
                <strong>{{ error }}</strong>
            </span>
    </div>
</template>

<script>
import fetchData from '@/api/fetch-data';
export default {
  name: 'SelectList',
  props: ['currentField', 'storeInArray', 'value', 'error'],
  data() {
    return {
      selected: this.currentField.multiple ? [] : null,
      update: true,
      loading: false
    }
  },

  mounted() {
    if( this.value ) {
      this.selected = this.value
    }

    if (this.currentField.isFromFormList) {
      let dataUrl = '/lists/' + this.currentField.formListTag;
      let valueField = 'value';
      let labelField = 'label';
      let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField);
      promise.then((data) => {
        data.unshift({
          optionValue: null,
          optionLabel: "Select",
        })
        this.currentField.options = data;
      });
    }
  },
  computed: {
    attributesBinding() {
      var attr = {};
      attr.disabled = this.currentField.disabled;
      // attr.clearable = this.currentField.clearable;
      attr.multiple = this.currentField.multiple;
      // attr.filterable = this.currentField.filterable;
      return attr;
    }
  },
  methods: {
    reload() {
      this.update = false
      this.$nextTick(() => {
        this.update = true
      });
    }
  },
  watch: {
    'currentField.multiple'() {
      this.reload();
    },


    value (value) {
      this.selected = this.selected ?? (this.currentField.multiple ? [] : null)
    },

    selected(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value,
      })
    }
  }
}
</script>
